module.exports = __webpack_public_path__ + "static/media/cancel.752b1dba.svg";